<template>
  <el-dialog
    :title="title?title:'提示'"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :close-on-click-modal="false"
    :width="width || '80%'"
    :before-close="handleClose">
    <ElementForm
      v-if="dialogVisible"
      ref="form"
      :form.sync="newForm"
    />
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'im-form',
  props: {
    title: String,
    visible: {
      type: Boolean,
      default: false
    },
    form: {
      type: Array
    },
    width: String,
    defaultValue: Object
  },
  watch: {
    visible (vl) { this.dialogVisible = vl },
    dialogVisible (vl) { this.$emit('update:visible', vl) },
    form (vl) { this.newForm = vl },
    newForm (vl) { this.$emit('update:form', vl) },
    defaultValue (vl) { this.newDefaultValue = vl },
    newDefaultValue (vl) { this.$emit('update:defaultValue', vl) }
  },
  created () {
    this.init()
  },
  data () {
    return {
      dialogVisible: this.visible,
      newForm: this.$_.cloneDeepWith((this.form)),
      newDefaultValue: this.defaultValue
    }
  },
  methods: {
    init () {
      // 如果有默认值，初始化数据
      if (this.newDefaultValue) {
        this.newForm.map((v, i) => {
          if (this.newDefaultValue[v.attr]) {
            v.value = this.newDefaultValue[v.attr]
          }
        })
      }
    },
    handleClose () {
      this.dialogVisible = false
    },
    submit () {
      const state = this.$refs.form.validateForm()
      console.log('表单校验==>', state)
      if (state) {
        this.$emit('success', this.newForm)
        this.handleClose()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/IMForm/index.vue